import { render } from "./Acrylic.vue?vue&type=template&id=a3e5fe5e"
import script from "./Acrylic.vue?vue&type=script&lang=js"
export * from "./Acrylic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__